<template>
  <v-avatar
    tile
    color="secondaryBackground bordered-2"
    :class="`rounded-${rounded}`"
    :size="deviceSize.mobile ? size * 0.75 : size"
  >
    <!-- :style="{
      border: `2px solid ${$vuetify.theme.currentTheme.background3} !important`,
    }" -->
    <v-progress-circular
      v-if="logoLoading || loading"
      indeterminate
      :size="size / 3"
      width="5"
      color="loading"
    />
    <v-icon
      v-else-if="!logo?.length"
      :size="deviceSize.mobile ? size / 2.5 : size / 2"
    >
      mdi-folder-account
    </v-icon>
    <v-img
      v-else
      contain
      :src="logo"
      :max-height="size"
      :max-width="size"
      :alt="`${$options.filters.capitalize(account.name)} Logo`"
    >
      <template #placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            :size="size / 3"
            width="5"
            color="loading"
          />
        </v-row>
      </template>
    </v-img>
  </v-avatar>
</template>

<script>
// Libraries
import { mapGetters } from "vuex";
import {
  // Firestore
  firestore,
  getDoc,
  doc,
  // Storage
  storage,
  ref,
  getDownloadURL,
} from "@/firebase/init";
// Components

export default {
  name: "AccountLogoImage",
  props: {
    account: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    size: {
      default: 64,
      type: Number,
    },
    rounded: {
      default: "lg",
      type: String,
    },
  },
  data() {
    return {
      logoLoaded: false,
      logoLoading: false,
      logo: null,
    };
  },
  watch: {
    account: {
      handler(newAccount, oldAccount) {
        // Only re-fetch if the account ID actually changed
        if (newAccount?.id !== oldAccount?.id) {
          this.updateAccountLogo(newAccount.id);
        }
      },
      immediate: false
    }
  },
  async mounted() {
    this.logoLoading = true;
    try {
      this.logo = await this.fetchLogo(this.account.id, this.$cacheManager);
    } finally {
      this.logoLoading = false;
    }
  },
  methods: {
    async updateAccountLogo(accountID) {
      this.logoLoading = true;
      this.logo = null;
      try {
        this.logo = await this.fetchLogo(accountID, this.$cacheManager);
      } finally {
        this.logoLoading = false;
      }
    },
    async fetchLogo(accountID, cacheManager) {
      try {
        const cachedLogo = cacheManager.get(accountID);
        if (cachedLogo || cacheManager.hasKey(accountID)) {
          return cachedLogo ?? null; // Use cached logo if available
        }
        // Fetch logo details from Firestore
        const accountsDoc = doc(firestore, "accounts", accountID);
        const response = await getDoc(accountsDoc);
        if (!response.exists() || !response.data().logo) {
          cacheManager.set(accountID, null);
          return null;
        }

        const mediaDoc = doc(firestore, "media", response.data().logo);
        const mediaResponse = await getDoc(mediaDoc);
        if (!mediaResponse.exists()) {
          cacheManager.set(accountID, null);
          return null;
        }

        const path = mediaResponse.data().path;
        const result = await getDownloadURL(ref(storage, path));

        cacheManager.set(accountID, result);
        return result;
      } catch (error) {
        console.error("Error fetching logo:", error);
        return null;
      }
    },
  },
  computed: {
    ...mapGetters([
      // Main
      "getAppName",
      "getUser",
    ]),
  },
};
</script>

<style></style>
